<template>
  <el-container>
    <el-header height="auto">
      <el-card>支持在2~36进制之间进行任意转换，不支持浮点型，数据过大会出错。（后续修改）</el-card>
    </el-header>    
    <el-main>
      <el-form size="small" @submit.native.prevent label-width="80px">
        <el-form-item label="二进制">
          <el-input v-model="bin"></el-input>
        </el-form-item>
        <el-form-item label="八进制">
          <el-input v-model="oct"></el-input>
        </el-form-item>
        <el-form-item label="十进制">
          <el-input v-model="dec"></el-input>
        </el-form-item>
        <el-form-item label="十六进制">
          <el-input v-model="hex"></el-input>
        </el-form-item>
        <el-form-item :label="n + '进制'">
          <el-input v-model="nConversion"></el-input>
          <el-slider v-model="n" :min="2" :max="36"></el-slider>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
function conversion(n) {
  return {
    set: function(value) {
      this.i = parseInt(value, n);
    },
    get: function() {
      return this.i.toString(n);
    }
  };
}
export default {
  name: "NumberConversion",
  data() {
    return {
      n: 36,
      i: 0
    };
  },
  computed: {
    bin: conversion(2),
    oct: conversion(8),
    dec: conversion(10),
    hex: conversion(16),
    // nConversion: conversion(this.n),
    nConversion: {
      set: function(value) {
        this.i = parseInt(value, this.n);
      },
      get: function() {
        return this.i.toString(this.n);
      }
    }
  }
};
</script>
